import React from 'react';
import { EnterTabName } from './EnterTabName';

const validateTabName = (tabName: string) => {
  let validation: string | undefined;

  switch (true) {
    case !tabName:
      validation = 'Please enter a tab name';
      break;
    case tabName.length < 4:
      validation = 'Tab name must contain more than 3 characters';
      break;
    default:
      break;
  }
  return validation;
};

export interface EnterTabNameContainerProps {
  service?: any;
  connection?: any;
  isPw365Project?: boolean;
  tabName: string;
  setTabName: (tabName: string) => any;
  serviceDisplayName?: string;
  connectionName?: string;
}

export class EnterTabNameContainer extends React.Component<EnterTabNameContainerProps> {
  async componentDidMount() {
    this.props.setTabName(this.defaultName());
  }

  defaultName = () => {
    if (!this.props.connectionName) {
      if (!this.props.serviceDisplayName && this.props.isPw365Project) {
        return 'ProjectWise 365';
      }

      return this.props.serviceDisplayName ?? '';
    }

    return this.props.connectionName;
  };

  render() {
    const { setTabName, tabName, connectionName, isPw365Project } = this.props;

    return (
      <EnterTabName
        onTabNameChange={setTabName}
        defaultValue={this.defaultName()}
        errorLabel={validateTabName(tabName)}
        connectionName={connectionName}
        isPw365Project={isPw365Project}
      />
    );
  }
}
